import * as React from 'react';

/** Ten sam próg co `md` w Tailwindzie — obie warstwy muszą się zgadzać. */
export const MOBILE_BREAKPOINT = 768;

const MOBILE_QUERY = `(max-width: ${MOBILE_BREAKPOINT - 1}px)`;

/**
 * Ten sam odczyt poza Reactem — dla `beforeLoad` tras, które muszą rozstrzygnąć
 * kierunek przekierowania, zanim cokolwiek się wyrenderuje.
 */
export const isMobileViewport = () => window.matchMedia(MOBILE_QUERY).matches;

/**
 * Stan czytany synchronicznie przy pierwszym renderze: gdy zaczynał od
 * `undefined`, telefon dostawał jedną klatkę układu desktopowego (margines
 * sidebara, pasek zakładek) zanim efekt zdążył go poprawić.
 */
export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState(
    () => window.matchMedia(MOBILE_QUERY).matches,
  );

  React.useEffect(() => {
    const mql = window.matchMedia(MOBILE_QUERY);
    const onChange = (event: MediaQueryListEvent) => setIsMobile(event.matches);

    mql.addEventListener('change', onChange);
    setIsMobile(mql.matches);
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return isMobile;
}
